export default {
  en: {
    // {{nom}}, {{gen}}, {{adv}} — название изучаемого языка, подставляет
    // `useStepsT` в steps.tsx (формы — `entities/user/model/languageForms.i18n.ts`).
    welcome: {
      continueLabel: 'Get started',
    },
    appLanguage: {
      title: 'Choose the app language',
    },
    selectMultiple: 'You can pick several',
    agreementQuestion: 'Do you agree with this statement?',
    learningLanguage: {
      title: 'What language do you want to learn?',
      // Подпись под родным названием языка (English / Deutsch / Português) —
      // на языке интерфейса: так выбор читают те, кто ещё не знает язык.
      names: {
        en: 'English',
        de: 'German',
        pt: 'Portuguese',
      },
    },
    valueIntro: {
      title: "Let's tailor the app to you",
      subtitle: 'A couple of questions to make our conversations more interesting — and <b>a free level check at the end</b>.',
    },
    goals: {
      title: 'Why do you need {{nom}}?',
    },
    speakingDifficulty: {
      title: "What's stopping you from speaking freely?",
    },
    difficultyStatements: {
      freeze: "I know what I want to say, but I freeze and go silent when it's time to speak.",
      find_words: "I know what I want to say, but I can't find the right words.",
      grammar: "I'm afraid to start speaking because I worry about grammar mistakes.",
      slow: 'I need a lot of time to form a reply, and it throws off the conversation.',
      accent: 'People struggle to understand me because of my pronunciation.',
      none: "Overall, speaking {{nom}} isn't that hard for me.",
    },
    dailyUsage: {
      title: 'How do you use {{nom}} in everyday life?',
    },
    workField: {
      title: 'What field do you work in?',
    },
    statMotivation: {
      title: 'Confident {{nom}} opens more doors',
      subtitle:
        'Working with international teams, relocating, meeting new people — it almost always starts with a confident conversation.',
    },
    age: {
      title: 'How old are you?',
      subtitle: 'Helps us pick the right pace and topics for your lessons',
    },
    gender: {
      title: 'Your gender?',
    },
    name: {
      title: 'What should we call you?',
      label: 'Your name',
      placeholder: 'Your name',
    },
    currentMethods: {
      title: 'What do you currently use to learn {{nom}}?',
    },
    statRecall: {
      title: 'Active recall works better',
      subtitle:
        'When you recall a word yourself instead of just reading the translation, it sticks better. This is called the testing effect.',
      illustration: {
        passive: 'Passive reading',
        active: 'Active practice',
      },
    },
    vocabGap: {
      title: 'Do you feel your {{nom}} vocabulary is lacking?',
    },
    progressQuit: {
      title: "Have you ever quit learning {{nom}} because you couldn't see progress?",
    },
    progressTracking: {
      title: 'See your progress — reach your goal',
      subtitle:
        'Tracking progress makes you more likely to reach your goal — the conclusion of 138 studies with almost 20,000 participants.',
      source: 'University of Sheffield',
      sourceNote: 'Harkin et al., Psychological Bulletin, 2016',
    },
    mistakeFear: {
      title: 'Are you afraid of making mistakes when you speak {{nom}}?',
    },
    mistakesFuel: {
      title: 'Mistakes are fuel — if you work through them',
      subtitle:
        'When mistakes are corrected during practice, grammar improves noticeably faster — a review of 15 years of research found.',
      source: 'University of Toronto',
      sourceNote: 'Russell & Spada, 2006',
    },
    demoFootnote: '* Actual app features',
    howItWorks: {
      title: 'Track your mistakes',
    },
    dictionaryDemo: {
      title: 'Learn new vocabulary',
    },
    practiceDemo: {
      title: 'Talk about anything',
    },
    progressDemo: {
      title: 'Watch your progress',
    },
    challenges: {
      title: 'What do you struggle with when learning {{nom}}?',
    },
    speakingFeelings: {
      title: 'How do you feel when you need to speak {{nom}}?',
    },
    feelingsStatements: {
      anxious: 'When I need to speak {{nom}}, I start feeling anxious and sweaty.',
      freeze: 'In the middle of a conversation I freeze and forget even simple words.',
      avoid: 'I try to avoid situations where I have to speak {{nom}}.',
      embarrassed: "I can speak, but it makes me feel embarrassed.",
      confident: 'Overall I feel fairly confident.',
    },
    hardestPart: {
      title: "What's the hardest part of a conversation for you?",
    },
    reassurance: {
      title: "You're not alone",
      subtitle:
        "Many people study {{nom}} for years and still get lost in a real conversation — it's a normal part of the journey, not a personal failure.",
    },
    level: {
      title: "What's your current {{nom}} level?",
    },
    assessmentTeaser: {
      title: 'Many people underestimate their level',
      subtitle: "That's normal. Next we'll check for real — by voice, not by guesswork.",
    },
    interests: {
      title: 'What are you into?',
    },
    tutor: {
      continueLabel: 'Choose companion',
    },
    done: {
      continueLabel: 'Continue',
    },
  },
  ru: {
    welcome: {
      continueLabel: 'Начать',
    },
    appLanguage: {
      title: 'Выбери язык приложения',
    },
    selectMultiple: 'Можно выбрать несколько',
    agreementQuestion: 'Согласен с утверждением?',
    learningLanguage: {
      title: 'Какой язык ты хочешь изучать?',
      // Подпись под родным названием языка (English / Deutsch / Português) —
      // на языке интерфейса: так выбор читают те, кто ещё не знает язык.
      names: {
        en: 'Английский',
        de: 'Немецкий',
        pt: 'Португальский',
      },
    },
    valueIntro: {
      title: 'Настроим приложение под тебя',
      subtitle: 'Пара вопросов, чтобы разговоры были интереснее, — и <b>бесплатная проверка уровня в конце</b>.',
    },
    goals: {
      title: 'Зачем тебе {{nom}}?',
    },
    speakingDifficulty: {
      title: 'Что мешает тебе говорить свободно?',
    },
    difficultyStatements: {
      freeze: 'Я знаю, что хочу сказать, но в момент разговора теряюсь и молчу.',
      find_words: 'Я знаю, что хочу сказать, но не могу подобрать нужные слова.',
      grammar: 'Я боюсь начать говорить, потому что переживаю из-за ошибок в грамматике.',
      slow: 'Мне нужно много времени, чтобы сформулировать ответ, и это сбивает разговор.',
      accent: 'Из-за моего произношения собеседники меня плохо понимают.',
      none: 'В целом мне не так уж сложно говорить {{adv}}.',
    },
    dailyUsage: {
      title: 'Как ты используешь {{nom}} в жизни?',
    },
    workField: {
      title: 'В какой сфере ты работаешь?',
    },
    statMotivation: {
      title: 'Уверенный {{nom}} открывает больше дверей',
      subtitle:
        'Работа с международными командами, переезд, новые знакомства — почти всегда начинается с уверенного разговора.',
    },
    age: {
      title: 'Сколько тебе лет?',
      subtitle: 'Поможет подобрать темп и темы занятий',
    },
    gender: {
      title: 'Твой пол?',
    },
    name: {
      title: 'Как к тебе обращаться?',
      label: 'Твоё имя',
      placeholder: 'Твоё имя',
    },
    currentMethods: {
      title: 'Чем сейчас пользуешься для {{gen}}?',
    },
    statRecall: {
      title: 'Активное вспоминание работает лучше',
      subtitle:
        'Когда ты вспоминаешь слово сам, а не просто читаешь перевод — оно запоминается прочнее. Это называют эффектом тестирования.',
      illustration: {
        passive: 'Пассивное чтение',
        active: 'Активная практика',
      },
    },
    vocabGap: {
      title: 'Чувствуешь, что не хватает словарного запаса?',
    },
    progressQuit: {
      title: 'Бросал учить {{nom}}, потому что не видел прогресса?',
    },
    progressTracking: {
      title: 'Видишь прогресс — доходишь до цели',
      subtitle:
        'Отслеживание прогресса повышает шанс достичь цели — вывод 138 исследований с почти 20 000 участников.',
      source: 'University of Sheffield',
      sourceNote: 'Harkin et al., Psychological Bulletin, 2016',
    },
    mistakeFear: {
      title: 'Боишься ошибиться, когда говоришь {{adv}}?',
    },
    mistakesFuel: {
      title: 'Ошибки — это топливо, если их разбирать',
      subtitle:
        'Когда ошибки исправляют во время практики, грамматика растёт заметно быстрее — показал обзор исследований за 15 лет.',
      source: 'University of Toronto',
      sourceNote: 'Russell & Spada, 2006',
    },
    demoFootnote: '* Функционал приложения',
    howItWorks: {
      title: 'Отслеживай ошибки',
    },
    dictionaryDemo: {
      title: 'Изучай новую лексику',
    },
    practiceDemo: {
      title: 'Говори о чём угодно',
    },
    progressDemo: {
      title: 'Следи за прогрессом',
    },
    challenges: {
      title: 'С чем ты сталкиваешься при изучении {{gen}}?',
    },
    speakingFeelings: {
      title: 'Что ты чувствуешь, когда нужно говорить {{adv}}?',
    },
    feelingsStatements: {
      anxious: 'Когда нужно говорить {{adv}}, я начинаю нервничать и потеть.',
      freeze: 'В момент разговора я теряюсь и забываю даже простые слова.',
      avoid: 'Я стараюсь избегать ситуаций, где придётся говорить {{adv}}.',
      embarrassed: 'Я могу говорить, но мне из-за этого неловко.',
      confident: 'В целом я чувствую себя достаточно уверенно.',
    },
    hardestPart: {
      title: 'Что самое сложное в разговоре для тебя?',
    },
    reassurance: {
      title: 'Ты не один',
      subtitle:
        'Многие годами учат {{nom}} и всё равно теряются в живом разговоре — это нормальная часть пути, а не твой личный провал.',
    },
    level: {
      title: 'Какой у тебя сейчас уровень {{gen}}?',
    },
    assessmentTeaser: {
      title: 'Многие недооценивают свой уровень',
      subtitle: 'Это нормально. Дальше проверим по-настоящему — на голосе, а не на глаз.',
    },
    interests: {
      title: 'Чем ты увлекаешься?',
    },
    tutor: {
      continueLabel: 'Выбрать собеседника',
    },
    done: {
      continueLabel: 'Продолжить',
    },
  },
  de: {
    welcome: {
      continueLabel: 'Los geht’s',
    },
    appLanguage: {
      title: 'Wähle die App-Sprache',
    },
    selectMultiple: 'Du kannst mehrere auswählen',
    agreementQuestion: 'Stimmst du dieser Aussage zu?',
    learningLanguage: {
      title: 'Welche Sprache möchtest du lernen?',
      names: {
        en: 'Englisch',
        de: 'Deutsch',
        pt: 'Portugiesisch',
      },
    },
    valueIntro: {
      title: 'Wir passen die App an dich an',
      subtitle: 'Ein paar Fragen, damit unsere Gespräche spannender werden — und <b>ein kostenloser Einstufungstest am Ende</b>.',
    },
    goals: {
      title: 'Wozu brauchst du {{nom}}?',
    },
    speakingDifficulty: {
      title: 'Was hält dich davon ab, frei zu sprechen?',
    },
    difficultyStatements: {
      freeze: 'Ich weiß, was ich sagen will, aber im Gespräch blockiere ich und schweige.',
      find_words: 'Ich weiß, was ich sagen will, aber ich finde nicht die richtigen Worte.',
      grammar: 'Ich habe Angst anzufangen, weil ich mir Sorgen wegen Grammatikfehlern mache.',
      slow: 'Ich brauche viel Zeit, um eine Antwort zu formulieren, und das bringt das Gespräch durcheinander.',
      accent: 'Wegen meiner Aussprache verstehen mich meine Gesprächspartner schlecht.',
      none: 'Insgesamt ist {{adv}} sprechen für mich nicht so schwer.',
    },
    dailyUsage: {
      title: 'Wie nutzt du {{nom}} im Alltag?',
    },
    workField: {
      title: 'In welchem Bereich arbeitest du?',
    },
    statMotivation: {
      title: 'Wenn du {{nom}} sicher sprichst, öffnen sich mehr Türen',
      subtitle:
        'Arbeit in internationalen Teams, Auswandern, neue Leute kennenlernen — fast immer beginnt es mit einem sicheren Gespräch.',
    },
    age: {
      title: 'Wie alt bist du?',
      subtitle: 'Hilft uns, Tempo und Themen für deine Lektionen passend zu wählen',
    },
    gender: {
      title: 'Dein Geschlecht?',
    },
    name: {
      title: 'Wie sollen wir dich nennen?',
      label: 'Dein Name',
      placeholder: 'Dein Name',
    },
    currentMethods: {
      title: 'Was nutzt du gerade, um {{gen}} zu lernen?',
    },
    statRecall: {
      title: 'Aktives Abrufen funktioniert besser',
      subtitle:
        'Wenn du dir ein Wort selbst abrufst, statt nur die Übersetzung zu lesen, prägt es sich besser ein. Das nennt man den Testing-Effekt.',
      illustration: {
        passive: 'Passives Lesen',
        active: 'Aktive Übung',
      },
    },
    vocabGap: {
      title: 'Hast du das Gefühl, dass dir Vokabeln fehlen?',
    },
    progressQuit: {
      title: 'Hast du schon mal aufgehört, {{nom}} zu lernen, weil du keinen Fortschritt gesehen hast?',
    },
    progressTracking: {
      title: 'Fortschritt sehen — Ziel erreichen',
      subtitle:
        'Fortschritt zu verfolgen erhöht die Chance, das Ziel zu erreichen — das Ergebnis von 138 Studien mit fast 20.000 Teilnehmenden.',
      source: 'University of Sheffield',
      sourceNote: 'Harkin et al., Psychological Bulletin, 2016',
    },
    mistakeFear: {
      title: 'Hast du Angst, Fehler zu machen, wenn du {{adv}} sprichst?',
    },
    mistakesFuel: {
      title: 'Fehler sind Treibstoff — wenn man sie aufarbeitet',
      subtitle:
        'Wenn Fehler während der Übung korrigiert werden, verbessert sich die Grammatik spürbar schneller — so das Fazit eines Forschungsüberblicks über 15 Jahre.',
      source: 'University of Toronto',
      sourceNote: 'Russell & Spada, 2006',
    },
    demoFootnote: '* Funktionen der App',
    howItWorks: {
      title: 'Verfolge deine Fehler',
    },
    dictionaryDemo: {
      title: 'Lerne neuen Wortschatz',
    },
    practiceDemo: {
      title: 'Sprich über alles',
    },
    progressDemo: {
      title: 'Behalte deinen Fortschritt im Blick',
    },
    challenges: {
      title: 'Was fällt dir beim Lernen von {{gen}} schwer?',
    },
    speakingFeelings: {
      title: 'Wie fühlst du dich, wenn du {{adv}} sprechen musst?',
    },
    feelingsStatements: {
      anxious: 'Wenn ich {{adv}} sprechen muss, werde ich nervös und fange an zu schwitzen.',
      freeze: 'Mitten im Gespräch blockiere ich und vergesse sogar einfache Wörter.',
      avoid: 'Ich versuche, Situationen zu vermeiden, in denen ich {{adv}} sprechen müsste.',
      embarrassed: 'Ich kann sprechen, aber es ist mir dabei unangenehm.',
      confident: 'Insgesamt fühle ich mich ziemlich sicher.',
    },
    hardestPart: {
      title: 'Was ist für dich das Schwierigste an einem Gespräch?',
    },
    reassurance: {
      title: 'Du bist nicht allein',
      subtitle:
        'Viele lernen jahrelang {{nom}} und verlieren sich trotzdem im echten Gespräch — das ist ein normaler Teil des Wegs, kein persönliches Scheitern.',
    },
    level: {
      title: 'Welches Niveau hast du aktuell in {{gen}}?',
    },
    assessmentTeaser: {
      title: 'Viele unterschätzen ihr Niveau',
      subtitle: 'Das ist normal. Danach prüfen wir es richtig — per Stimme, nicht per Bauchgefühl.',
    },
    interests: {
      title: 'Wofür begeisterst du dich?',
    },
    tutor: {
      continueLabel: 'Gesprächspartner wählen',
    },
    done: {
      continueLabel: 'Weiter',
    },
  },
  pt: {
    welcome: {
      continueLabel: 'Começar',
    },
    appLanguage: {
      title: 'Escolha o idioma do app',
    },
    selectMultiple: 'Você pode escolher vários',
    agreementQuestion: 'Você concorda com essa afirmação?',
    learningLanguage: {
      title: 'Qual idioma você quer aprender?',
      names: {
        en: 'Inglês',
        de: 'Alemão',
        pt: 'Português',
      },
    },
    valueIntro: {
      title: 'Vamos ajustar o app para você',
      subtitle: 'Algumas perguntas para deixar nossas conversas mais interessantes — e <b>uma avaliação de nível gratuita no final</b>.',
    },
    goals: {
      title: 'Por que você precisa de {{nom}}?',
    },
    speakingDifficulty: {
      title: 'O que impede você de falar com liberdade?',
    },
    difficultyStatements: {
      freeze: 'Eu sei o que quero dizer, mas na hora da conversa eu travo e fico em silêncio.',
      find_words: 'Eu sei o que quero dizer, mas não consigo achar as palavras certas.',
      grammar: 'Tenho medo de começar a falar porque me preocupo com erros de gramática.',
      slow: 'Preciso de muito tempo para formular uma resposta, e isso atrapalha a conversa.',
      accent: 'Por causa da minha pronúncia, as pessoas me entendem mal.',
      none: 'No geral, falar {{adv}} não é tão difícil para mim.',
    },
    dailyUsage: {
      title: 'Como você usa {{nom}} no dia a dia?',
    },
    workField: {
      title: 'Em qual área você trabalha?',
    },
    statMotivation: {
      title: 'Falar {{nom}} com confiança abre mais portas',
      subtitle:
        'Trabalhar com equipes internacionais, mudar de país, conhecer pessoas novas — quase sempre começa com uma conversa confiante.',
    },
    age: {
      title: 'Quantos anos você tem?',
      subtitle: 'Ajuda a escolher o ritmo e os temas das suas aulas',
    },
    gender: {
      title: 'Seu gênero?',
    },
    name: {
      title: 'Como podemos te chamar?',
      label: 'Seu nome',
      placeholder: 'Seu nome',
    },
    currentMethods: {
      title: 'O que você usa hoje para aprender {{gen}}?',
    },
    statRecall: {
      title: 'A recordação ativa funciona melhor',
      subtitle:
        'Quando você lembra uma palavra por conta própria, em vez de só ler a tradução, ela fica melhor gravada. Isso se chama efeito de testagem.',
      illustration: {
        passive: 'Leitura passiva',
        active: 'Prática ativa',
      },
    },
    vocabGap: {
      title: 'Sente que falta vocabulário?',
    },
    progressQuit: {
      title: 'Já desistiu de aprender {{nom}} porque não via progresso?',
    },
    progressTracking: {
      title: 'Veja seu progresso — alcance sua meta',
      subtitle:
        'Acompanhar o progresso aumenta a chance de alcançar a meta — conclusão de 138 estudos com quase 20.000 participantes.',
      source: 'University of Sheffield',
      sourceNote: 'Harkin et al., Psychological Bulletin, 2016',
    },
    mistakeFear: {
      title: 'Tem medo de errar quando fala {{adv}}?',
    },
    mistakesFuel: {
      title: 'Erros são combustível — se você os analisa',
      subtitle:
        'Quando os erros são corrigidos durante a prática, a gramática melhora visivelmente mais rápido — mostrou uma revisão de 15 anos de pesquisas.',
      source: 'University of Toronto',
      sourceNote: 'Russell & Spada, 2006',
    },
    demoFootnote: '* Funcionalidades do app',
    howItWorks: {
      title: 'Acompanhe seus erros',
    },
    dictionaryDemo: {
      title: 'Aprenda vocabulário novo',
    },
    practiceDemo: {
      title: 'Fale sobre qualquer coisa',
    },
    progressDemo: {
      title: 'Acompanhe seu progresso',
    },
    challenges: {
      title: 'Com o que você tem dificuldade ao aprender {{gen}}?',
    },
    speakingFeelings: {
      title: 'O que você sente quando precisa falar {{adv}}?',
    },
    feelingsStatements: {
      anxious: 'Quando preciso falar {{adv}}, começo a sentir nervosismo e a suar.',
      freeze: 'No meio da conversa, eu travo e esqueço até palavras simples.',
      avoid: 'Tento evitar situações em que precisaria falar {{adv}}.',
      embarrassed: 'Consigo falar, mas sinto vergonha por isso.',
      confident: 'No geral, me sinto bastante confiante.',
    },
    hardestPart: {
      title: 'O que é mais difícil para você numa conversa?',
    },
    reassurance: {
      title: 'Você não está sozinho',
      subtitle:
        'Muita gente estuda {{nom}} por anos e ainda se perde numa conversa real — isso é uma parte normal do caminho, não um fracasso seu.',
    },
    level: {
      title: 'Qual é o seu nível atual de {{gen}}?',
    },
    assessmentTeaser: {
      title: 'Muita gente subestima o próprio nível',
      subtitle: 'Isso é normal. A seguir vamos verificar de verdade — pela voz, não por achismo.',
    },
    interests: {
      title: 'Do que você gosta?',
    },
    tutor: {
      continueLabel: 'Escolher companheiro',
    },
    done: {
      continueLabel: 'Continuar',
    },
  },
  fr: {
    welcome: {
      continueLabel: 'C’est parti',
    },
    appLanguage: {
      title: 'Choisis la langue de l’appli',
    },
    selectMultiple: 'Tu peux en choisir plusieurs',
    agreementQuestion: 'Es-tu d’accord avec cette affirmation ?',
    learningLanguage: {
      title: 'Quelle langue veux-tu apprendre ?',
      names: {
        en: 'Anglais',
        de: 'Allemand',
        pt: 'Portugais',
      },
    },
    valueIntro: {
      title: 'Adaptons l’appli à toi',
      subtitle: 'Quelques questions pour rendre nos conversations plus intéressantes — et <b>un test de niveau gratuit à la fin</b>.',
    },
    goals: {
      title: 'Pourquoi apprendre {{nom}} ?',
    },
    speakingDifficulty: {
      title: 'Qu’est-ce qui t’empêche de parler librement ?',
    },
    difficultyStatements: {
      freeze: 'Je sais ce que je veux dire, mais au moment de parler je bloque et je me tais.',
      find_words: 'Je sais ce que je veux dire, mais je ne trouve pas les bons mots.',
      grammar: 'J’ai peur de commencer à parler parce que je m’inquiète des fautes de grammaire.',
      slow: 'J’ai besoin de beaucoup de temps pour formuler une réponse, et ça casse la conversation.',
      accent: 'À cause de ma prononciation, mes interlocuteurs me comprennent mal.',
      none: 'Dans l’ensemble, parler {{adv}} n’est pas si difficile pour moi.',
    },
    dailyUsage: {
      title: 'Comment utilises-tu {{nom}} au quotidien ?',
    },
    workField: {
      title: 'Dans quel domaine travailles-tu ?',
    },
    statMotivation: {
      title: 'Parler {{nom}} avec assurance ouvre plus de portes',
      subtitle:
        'Travailler avec des équipes internationales, s’expatrier, faire de nouvelles rencontres — presque tout commence par une conversation assurée.',
    },
    age: {
      title: 'Quel âge as-tu ?',
      subtitle: 'Cela nous aide à choisir le rythme et les sujets de tes leçons',
    },
    gender: {
      title: 'Ton genre ?',
    },
    name: {
      title: 'Comment peut-on t’appeler ?',
      label: 'Ton prénom',
      placeholder: 'Ton prénom',
    },
    currentMethods: {
      title: 'Qu’utilises-tu en ce moment pour apprendre {{gen}} ?',
    },
    statRecall: {
      title: 'Le rappel actif fonctionne mieux',
      subtitle:
        'Quand tu retrouves toi-même un mot au lieu de lire simplement la traduction, il se grave mieux en mémoire. C’est ce qu’on appelle l’effet de test.',
      illustration: {
        passive: 'Lecture passive',
        active: 'Pratique active',
      },
    },
    vocabGap: {
      title: 'As-tu l’impression qu’il te manque du vocabulaire ?',
    },
    progressQuit: {
      title: 'As-tu déjà arrêté d’apprendre {{nom}} parce que tu ne voyais pas de progrès ?',
    },
    progressTracking: {
      title: 'Vois tes progrès — atteins ton objectif',
      subtitle:
        'Suivre ses progrès augmente les chances d’atteindre son objectif — conclusion de 138 études avec près de 20 000 participants.',
      source: 'University of Sheffield',
      sourceNote: 'Harkin et al., Psychological Bulletin, 2016',
    },
    mistakeFear: {
      title: 'As-tu peur de faire des fautes quand tu parles {{adv}} ?',
    },
    mistakesFuel: {
      title: 'Les erreurs sont un carburant — à condition de les exploiter',
      subtitle:
        'Quand les erreurs sont corrigées pendant la pratique, la grammaire progresse visiblement plus vite — selon une revue de 15 années de recherche.',
      source: 'University of Toronto',
      sourceNote: 'Russell & Spada, 2006',
    },
    demoFootnote: '* Fonctionnalités de l’appli',
    howItWorks: {
      title: 'Suis tes erreurs',
    },
    dictionaryDemo: {
      title: 'Apprends du nouveau vocabulaire',
    },
    practiceDemo: {
      title: 'Parle de tout',
    },
    progressDemo: {
      title: 'Suis tes progrès',
    },
    challenges: {
      title: 'Qu’est-ce qui est difficile pour toi quand tu apprends {{gen}} ?',
    },
    speakingFeelings: {
      title: 'Que ressens-tu quand tu dois parler {{adv}} ?',
    },
    feelingsStatements: {
      anxious: 'Quand je dois parler {{adv}}, je commence à stresser et à transpirer.',
      freeze: 'En pleine conversation, je bloque et j’oublie même les mots simples.',
      avoid: 'J’essaie d’éviter les situations où je devrais parler {{adv}}.',
      embarrassed: 'Je peux parler, mais ça me met mal à l’aise.',
      confident: 'Dans l’ensemble, je me sens plutôt à l’aise.',
    },
    hardestPart: {
      title: 'Qu’est-ce qui est le plus difficile pour toi dans une conversation ?',
    },
    reassurance: {
      title: 'Tu n’es pas seul',
      subtitle:
        'Beaucoup de gens apprennent {{nom}} pendant des années et se perdent quand même dans une vraie conversation — c’est une étape normale du parcours, pas un échec personnel.',
    },
    level: {
      title: 'Quel est ton niveau actuel en {{gen}} ?',
    },
    assessmentTeaser: {
      title: 'Beaucoup sous-estiment leur niveau',
      subtitle: 'C’est normal. Ensuite, on vérifiera pour de vrai — à la voix, pas au hasard.',
    },
    interests: {
      title: 'Qu’est-ce qui te passionne ?',
    },
    tutor: {
      continueLabel: 'Choisir l’interlocuteur',
    },
    done: {
      continueLabel: 'Continuer',
    },
  },
  es: {
    welcome: {
      continueLabel: 'Empezar',
    },
    appLanguage: {
      title: 'Elige el idioma de la app',
    },
    selectMultiple: 'Puedes elegir varios',
    agreementQuestion: '¿Estás de acuerdo con esta afirmación?',
    learningLanguage: {
      title: '¿Qué idioma quieres aprender?',
      names: {
        en: 'Inglés',
        de: 'Alemán',
        pt: 'Portugués',
      },
    },
    valueIntro: {
      title: 'Ajustemos la app a ti',
      subtitle: 'Un par de preguntas para que nuestras conversaciones sean más interesantes — y <b>una evaluación de nivel gratuita al final</b>.',
    },
    goals: {
      title: '¿Por qué necesitas {{nom}}?',
    },
    speakingDifficulty: {
      title: '¿Qué te impide hablar con libertad?',
    },
    difficultyStatements: {
      freeze: 'Sé lo que quiero decir, pero en plena conversación me bloqueo y me quedo en silencio.',
      find_words: 'Sé lo que quiero decir, pero no encuentro las palabras correctas.',
      grammar: 'Tengo miedo de empezar a hablar porque me preocupa equivocarme en la gramática.',
      slow: 'Necesito mucho tiempo para formular una respuesta, y eso descarrila la conversación.',
      accent: 'Por mi pronunciación, los demás me entienden mal.',
      none: 'En general, hablar {{adv}} no es tan difícil para mí.',
    },
    dailyUsage: {
      title: '¿Cómo usas {{nom}} en tu día a día?',
    },
    workField: {
      title: '¿En qué área trabajas?',
    },
    statMotivation: {
      title: 'Hablar {{nom}} con confianza abre más puertas',
      subtitle:
        'Trabajar con equipos internacionales, mudarte al extranjero, conocer gente nueva — casi siempre empieza con una conversación segura.',
    },
    age: {
      title: '¿Cuántos años tienes?',
      subtitle: 'Nos ayuda a elegir el ritmo y los temas de tus lecciones',
    },
    gender: {
      title: '¿Tu género?',
    },
    name: {
      title: '¿Cómo te llamamos?',
      label: 'Tu nombre',
      placeholder: 'Tu nombre',
    },
    currentMethods: {
      title: '¿Qué usas ahora para aprender {{gen}}?',
    },
    statRecall: {
      title: 'La recuperación activa funciona mejor',
      subtitle:
        'Cuando recuerdas una palabra por tu cuenta, en lugar de solo leer la traducción, se te queda mejor grabada. A esto se le llama efecto de prueba.',
      illustration: {
        passive: 'Lectura pasiva',
        active: 'Práctica activa',
      },
    },
    vocabGap: {
      title: '¿Sientes que te falta vocabulario?',
    },
    progressQuit: {
      title: '¿Has dejado de aprender {{nom}} porque no veías progreso?',
    },
    progressTracking: {
      title: 'Ves tu progreso — alcanzas tu meta',
      subtitle:
        'Hacer un seguimiento del progreso aumenta las posibilidades de alcanzar la meta — conclusión de 138 estudios con casi 20.000 participantes.',
      source: 'University of Sheffield',
      sourceNote: 'Harkin et al., Psychological Bulletin, 2016',
    },
    mistakeFear: {
      title: '¿Tienes miedo de equivocarte cuando hablas {{adv}}?',
    },
    mistakesFuel: {
      title: 'Los errores son combustible — si los analizas',
      subtitle:
        'Cuando se corrigen los errores durante la práctica, la gramática mejora notablemente más rápido — mostró una revisión de 15 años de investigación.',
      source: 'University of Toronto',
      sourceNote: 'Russell & Spada, 2006',
    },
    demoFootnote: '* Funcionalidades de la app',
    howItWorks: {
      title: 'Sigue tus errores',
    },
    dictionaryDemo: {
      title: 'Aprende vocabulario nuevo',
    },
    practiceDemo: {
      title: 'Habla de lo que quieras',
    },
    progressDemo: {
      title: 'Sigue tu progreso',
    },
    challenges: {
      title: '¿Con qué tienes dificultades al aprender {{gen}}?',
    },
    speakingFeelings: {
      title: '¿Qué sientes cuando tienes que hablar {{adv}}?',
    },
    feelingsStatements: {
      anxious: 'Cuando tengo que hablar {{adv}}, empiezo a sentir nervios y a sudar.',
      freeze: 'En plena conversación, me bloqueo y olvido hasta las palabras más simples.',
      avoid: 'Intento evitar situaciones en las que tendría que hablar {{adv}}.',
      embarrassed: 'Puedo hablar, pero me da vergüenza.',
      confident: 'En general, me siento bastante seguro.',
    },
    hardestPart: {
      title: '¿Qué es lo más difícil de una conversación para ti?',
    },
    reassurance: {
      title: 'No estás solo',
      subtitle:
        'Mucha gente estudia {{nom}} durante años y aun así se pierde en una conversación real — es una parte normal del camino, no un fracaso personal.',
    },
    level: {
      title: '¿Cuál es tu nivel actual de {{gen}}?',
    },
    assessmentTeaser: {
      title: 'Mucha gente subestima su nivel',
      subtitle: 'Es normal. A continuación lo comprobaremos de verdad — con la voz, no a ojo.',
    },
    interests: {
      title: '¿Qué te apasiona?',
    },
    tutor: {
      continueLabel: 'Elegir compañero',
    },
    done: {
      continueLabel: 'Continuar',
    },
  },
};
